import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../redux/actions';

class Create extends Component {
  componentWillMount() {
    const { name, type, agreementStartType } = this.props.fields;

    if (!type) {
      if (agreementStartType) {
        this.props.router.push(`/create/${agreementStartType}`);
      } else {
        if (this.props.location.pathname === '/create/exist') {
          this.props.router.push('/create/exist');
        } else {
          this.props.router.push('/create/new');
        }
      }
    } else if (!name) {
      this.props.router.push('/create/product-props');
    }
  }

  componentWillUnmount() {
    // const { contractBlocks } = this.props;
    // console.log('contractBlocks: ', contractBlocks)

    this.props.resetAttribute();
    this.props.resetContractBlockContents();
  }

  render() {
    return <div className="create">{this.props.children}</div>;
  }
}

const mapStateToProps = (state) => ({
  fields: state.create.fields,
  contractBlocks: state.global.contractBlocks,
});

const mapDispatchToProps = (dispatch) => ({
  resetAttribute: () => {
    dispatch(actions.resetAttribute());
  },
  resetContractBlockContents: () => {
    dispatch(actions.resetContractBlockContents());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Create);



// WEBPACK FOOTER //
// src/pages/Create.jsx